
const routes = [
  {
    path: '/',
    redirect: '/auth/login'
    // component: () => import('layouts/MainLayout.vue'),
    // children: [
    //   { path: '', component: () => import('pages/Index.vue') }
    // ],
  },

  {
    path: '/auth',
    component: () => import('layouts/auth/Auth.vue'),
    children: [
      { path: 'login', name: 'auth-login', component: () => import('pages/auth/Login.vue') },
      { path: 'change-password', component: () => import('pages/auth/ChangePassword.vue') },
      { path: '*', redirect: 'login' },
      { path: '', redirect: 'login' }
    ]
  },

  {
    path: '/admin',
    component: () => import('layouts/admin/Admin.vue'),
    meta: { requireAuth: true },
    children: [
      { path: '', name: 'admin-index', component: () => import('pages/admin/Index.vue') },
      // Sunat
      { path: 'sunat/ticket', name: 'sunat-ticket', meta: {page: { title: 'Boleta', add: true }},component: () => import('src/pages/admin/sunat/ticket/Index.vue') },
      { path: 'sunat/ticket/detail', name: 'sunat-ticket-detail', meta: {page: { title: '', back: 'sunat-ticket' }},component: () => import('src/pages/admin/sunat/ticket/detail/Index.vue') },
      { path: 'sunat/document', name: 'sunat-document', meta: {page: { title: 'Documento' }},component: () => import('src/pages/admin/sunat/document/Index.vue') },
      { path: 'sunat/not-domiciled', name: 'sunat-notdomiciled', meta: {page: { title: 'No domiciliado', add: true }},component: () => import('src/pages/admin/sunat/not-domiciled/Index.vue') },
      { path: 'sunat/not-domiciled/detail', name: 'sunat-notdomiciled-detail', meta: {page: { title: '', back: 'sunat-notdomiciled' }},component: () => import('src/pages/admin/sunat/not-domiciled/detail/Index.vue') },
      { path: 'config/search', name: 'config-search', meta: {page: { title: 'Buscadores Netzun' }},component: () => import('src/pages/admin/config/search.vue') },
      { path: 'sorteo', name: 'sorteo', meta: {page: { title: 'Sorteo Netzun' }},component: () => import('src/pages/admin/raffle.vue') },
      { path: 'trivias', name: 'trivias', meta: {page: { title: 'Trivias Netzun' }},component: () => import('src/pages/admin/trivias.vue') },
    ]
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '*',
    component: () => import('pages/Error404.vue')
  }
]

export default routes
